import { render, staticRenderFns } from "./disbandTeamList.vue?vue&type=template&id=8de53b3a&scoped=true&"
import script from "./disbandTeamList.vue?vue&type=script&lang=js&"
export * from "./disbandTeamList.vue?vue&type=script&lang=js&"
import style0 from "./disbandTeamList.vue?vue&type=style&index=0&id=8de53b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de53b3a",
  null
  
)

export default component.exports